(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sgw-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sgw-tabs')) {
    class SgwTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.sgw-tabs__tab'));
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.toggle(tab)));
        this.addEventListener('keydown', (e) => this.onKey(e));
        this.syncDesktop();
        this.desktop.addEventListener('change', () => this.syncDesktop());
      }

      panelFor(tab) {
        return this.querySelector('#' + tab.getAttribute('aria-controls'));
      }

      select(tab, open) {
        tab.setAttribute('aria-selected', String(open));
        const panel = this.panelFor(tab);
        if (panel) panel.hidden = !open;
      }

      toggle(tab) {
        const isOpen = tab.getAttribute('aria-selected') === 'true';
        if (this.desktop.matches) {
          this.tabs.forEach((t) => this.select(t, t === tab));
        } else {
          this.tabs.forEach((t) => this.select(t, t === tab ? !isOpen : false));
        }
      }

      syncDesktop() {
        if (this.desktop.matches && !this.tabs.some((t) => t.getAttribute('aria-selected') === 'true') && this.tabs[0]) {
          this.select(this.tabs[0], true);
        }
      }

      onKey(e) {
        if (!this.desktop.matches || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0) return;
        const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
        next.focus();
        this.toggle(next);
      }
    }
    customElements.define('sgw-tabs', SgwTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
